var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrivers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00221 5.00586H2.34217C1.98892 5.00586 1.65015 5.14619 1.40036 5.39597C1.15058 5.64575 1.01025 5.98453 1.01025 6.33778V18.3259C1.01025 18.6792 1.15058 19.018 1.40036 19.2678C1.65015 19.5175 1.98892 19.6579 2.34217 19.6579H19.6585C20.0117 19.6579 20.3505 19.5175 20.6003 19.2678C20.8501 19.018 20.9904 18.6792 20.9904 18.3259V6.33778C20.9904 5.98453 20.8501 5.64575 20.6003 5.39597C20.3505 5.14619 20.0117 5.00586 19.6585 5.00586H12.9984",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9979 4.3399C12.9979 3.80997 12.7874 3.30175 12.4127 2.92703C12.038 2.55231 11.5297 2.3418 10.9998 2.3418C10.4699 2.3418 9.96166 2.55231 9.58694 2.92703C9.21222 3.30175 9.00171 3.80997 9.00171 4.3399V7.00419C9.00171 7.18082 9.07187 7.3502 9.19676 7.4751C9.32166 7.59999 9.49104 7.67015 9.66767 7.67015H12.332C12.5086 7.67015 12.678 7.59999 12.8029 7.4751C12.9278 7.3502 12.9979 7.18082 12.9979 7.00419V4.3399Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33862 12.6651C5.33862 12.9712 5.39892 13.2743 5.51607 13.5571C5.63321 13.84 5.80492 14.0969 6.02138 14.3134C6.23784 14.5299 6.49482 14.7016 6.77764 14.8187C7.06046 14.9359 7.36358 14.9962 7.66971 14.9962C7.97583 14.9962 8.27895 14.9359 8.56177 14.8187C8.84459 14.7016 9.10157 14.5299 9.31803 14.3134C9.53449 14.0969 9.7062 13.84 9.82335 13.5571C9.94049 13.2743 10.0008 12.9712 10.0008 12.6651C10.0008 12.3589 9.94049 12.0558 9.82335 11.773C9.7062 11.4902 9.53449 11.2332 9.31803 11.0167C9.10157 10.8003 8.84459 10.6286 8.56177 10.5114C8.27895 10.3943 7.97583 10.334 7.66971 10.334C7.36358 10.334 7.06046 10.3943 6.77764 10.5114C6.49482 10.6286 6.23784 10.8003 6.02138 11.0167C5.80492 11.2332 5.63321 11.4902 5.51607 11.773C5.39892 12.0558 5.33862 12.3589 5.33862 12.6651Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.67407 19.6583C3.67407 18.5985 4.0951 17.582 4.84453 16.8326C5.59397 16.0831 6.61042 15.6621 7.67028 15.6621C8.73014 15.6621 9.74659 16.0831 10.496 16.8326C11.2455 17.582 11.6665 18.5985 11.6665 19.6583H3.67407Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9978 11.666H16.994",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9978 14.3301H18.3259",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrivers);
export default __webpack_public_path__ + "static/media/Drivers.8beafad3d0152ce0f8109fa002e13f2a.svg";
export { ForwardRef as ReactComponent };